import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import {
  EFurnitureStyle,
  FurnitureStyleOption,
} from '../../models/wizard.model';

type StyleView = 'choose' | 'remove' | 'furnish';

@Component({
  selector: 'casa-doc-style-selection-step',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './style-selection-step.component.html',
  styleUrl: './style-selection-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StyleSelectionStepComponent implements OnInit {
  filesCount = input<number>(0);
  styles = input<FurnitureStyleOption[]>([]);
  furnitureStyle = input<EFurnitureStyle | null>(null);
  removeFurniture = input<boolean>(true);
  removePersonalEffects = input<boolean>(true);
  addCompanyLogo = input<boolean>(true);
  showCompanyOption = input<boolean>(false);
  canProceed = input<boolean>(false);

  back = output<void>();
  furnitureStyleChange = output<EFurnitureStyle>();
  removeFurnitureChange = output<boolean>();
  removePersonalEffectsChange = output<boolean>();
  addCompanyLogoChange = output<boolean>();
  proceed = output<void>();

  readonly removeFurnitureStyle = EFurnitureStyle.RIMUOVI_ARREDI;

  /** Which sub-screen of step 2 is visible. */
  readonly view = signal<StyleView>('choose');

  /** Furnish-grid styles: all options except the removal value. */
  readonly furnishStyles = computed(() =>
    this.styles().filter((s) => s.value !== EFurnitureStyle.RIMUOVI_ARREDI)
  );

  ngOnInit(): void {
    // Seed the view from the incoming selection so returning from step 3
    // restores the right sub-screen. Inputs are bound by ngOnInit time.
    const current = this.furnitureStyle();
    if (current === EFurnitureStyle.RIMUOVI_ARREDI) {
      this.view.set('remove');
    } else if (current) {
      this.view.set('furnish');
    }
  }

  onChooseRemove() {
    // Selecting the removal mode commits the removal "style" so the parent
    // resets both removal checkboxes to true (see onFurnitureStyleChange).
    this.furnitureStyleChange.emit(EFurnitureStyle.RIMUOVI_ARREDI);
    this.view.set('remove');
  }

  onChooseFurnish() {
    this.view.set('furnish');
  }

  onBackToChoose() {
    this.view.set('choose');
  }

  onSelectStyle(value: EFurnitureStyle) {
    this.furnitureStyleChange.emit(value);
  }

  onToggleCompanyLogo(event: Event) {
    this.addCompanyLogoChange.emit((event.target as HTMLInputElement).checked);
  }

  onToggleRemoveFurniture(event: Event) {
    this.removeFurnitureChange.emit((event.target as HTMLInputElement).checked);
  }

  onToggleRemovePersonalEffects(event: Event) {
    this.removePersonalEffectsChange.emit(
      (event.target as HTMLInputElement).checked
    );
  }
}
